export const
TOGGLE_PASSWORD_RESET_MODAL = 'TOGGLE_PASSWORD_RESET_MODAL',
UPDATE_REGISTRATION_STEP_STATUS = 'UPDATE_REGISTRATION_STEP_STATUS',
CLEAR_CANDIDATE_REGISTRATION_DATA = 'CLEAR_CANDIDATE_REGISTRATION_DATA',
CLEAR_CANDIDATE_REGISTRATION_REQUEST = 'CLEAR_CANDIDATE_REGISTRATION_REQUEST',
CANDIDATE_REGISTRATION_SUBMISSION_PENDING = 'CANDIDATE_REGISTRATION_SUBMISSION_PENDING',
CANDIDATE_REGISTRATION_SUBMISSION_SUCCESS = 'CANDIDATE_REGISTRATION_SUBMISSION_SUCCESS',
CANDIDATE_REGISTRATION_SUBMISSION_FAILURE = 'CANDIDATE_REGISTRATION_SUBMISSION_FAILURE';